// extracted by mini-css-extract-plugin
export default {"noViewsContainer":"style_noViewsContainer__5IY9I","image":"style_image__XamGo","title":"style_title__QLkK+","subTitle":"style_subTitle__t5Y6+"};